<template>
  <!-- Requiere la libreria de iconos  href="https://unicons.iconscout.com/release/v0.0.4/css/unicons.css"-->
  <div class="inner-addon right-addon" >

    <i class="uil uil-search glyphicon iconInput" v-show="isEmpty"></i>
    <i class="uil uil-times glyphicon iconInput" style="cursor:pointer" v-show="isDirty" @click="cleanQuery"></i>

    <vs-input
      :id="id"
      :class="[classes]"
      :placeholder="placeholder"
      class="inputTypeahead"
      autocomplete="off"
      v-model="query"
      autofocus="true"
      @keydown.down="down"
      @keydown.up="up"
      @keydown.enter="hit"
      @keydown.esc="reset"
      @keydown.tab="hit"
      @input="update"
    />

    <ul v-show="hasItems" class="typehead container">
      <li
        v-for="(item , index) in items"
        :class="{active:activeClass(index)}"
        class="listTypehead left-addon"
        :key="'li'+index"
        @click="hit"
        @mousemove="setActive(index)"
      >
        <span><i class='uil uil-location-point'></i></span>
        <a v-html="highlighting(item, vue)"></a>
      </li>
    </ul>

    <ul v-if="showSearchingFlag" v-show="!hasItems&&!isEmpty" class="typehead">
      <li class="active" @mousemove="setActive(index)" v-if="!loading">
        <a>
          <span v-html="NoResultText"></span>
        </a>
      </li>
      <li class="active" @mousemove="setActive(index)" v-else>
        <a>
          <span v-html="SearchingText"></span>
        </a>
      </li>
    </ul>

  </div>
</template>
<style scoped>
.dropdown-menu-list {
  display: list-item;
  width: 100%;
}
</style>
<script>
function escapeRegExp(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}

export default {
  name: "TypeAhead",
  props: {
    selectFirst: {
      // 是否选择第一个选项
      required: false,
      type: Boolean,
      default: false
    },
    id:{
      required: false,
      type: String,
    },
    queryParamName: {
      // 被替换的单词
      required: false,
      type: String,
      default: ":keyword"
    },
    limit: {
      // 最大显示量
      required: false,
      type: Number,
      default: 10
    },
    minChars: {
      // 最小进行查询的字符数量
      required: false,
      type: Number,
      default: 2
    },
    src: {
      // 请求地址
      required: false,
      type: String
    },
    delayTime: {
      // 发送延迟时间
      required: false,
      default: 500,
      type: Number
    },
    placeholder: {
      // 是否有placeholder
      required: false,
      type: String
    },
    showSearchingFlag: {
      // 是否显示搜索状态
      required: false,
      default: false,
      type: Boolean
    },
    NoResultText: {
      // 如果显示搜索状态，无结果的文本
      required: false,
      default: "No result",
      type: String
    },
    SearchingText: {
      // 如果显示搜索状态，搜索的文本
      required: false,
      default: "Searching...",
      type: String
    },
    classes: {
      // 所给填写框增加的类
      required: false,
      type: String
    },
    value: {
      required: false,
      type: String,
      default: ""
    },

    onHit: {
      required: false,
      type: Function,
      default: function(item) {
        this.query = item;
      }
    },

    highlighting: {
      // 高亮结果
      required: false,
      type: Function,
      default: function(item) {
        var re = new RegExp(escapeRegExp(this.query), "ig");
        var matches = item.match(re);

        matches &&
          matches.forEach(match => {
            item = item.replace(match, `<b>${match}</b>`);
          });

        return item;
      }
    },

    clean: {
      required: false,
      type: Function,
      default: function(){
         
      }
    },

    render: {
      // 对结果进行处理
      required: false,
      type: Function,
      default: function(items) {
        return items;
      }
    },

    getResponse: {
      // 如何处理得到的请求
      required: false,
      type: Function
    },

    fetch: {
      // 如何获取数据
      required: false,
      type: Function,
      default: function(url) {
        return axios.get(url);
      }
    },

    objectArray: {
      required: false,
      type: Array
    },

  },


  data() {
    return {
      items: [],
      query: "",
      current: -1,
      loading: false,
      lastTime: 0,
      data: []
    };
  },

  methods: {

    objectUpdate() {

      var filtered = this.objectArray.filter(entity =>
        entity.toLowerCase().includes(this.query.toLowerCase())
      );

      this.data = this.limit ? filtered.slice(0, this.limit) : filtered;
      this.items = this.render(
        this.limit ? this.data.slice(0, this.limit) : this.data,
        this
      );

      this.current = -1;

      if (this.selectFirst) {
        this.down();
      }
    },

    update(event) {
      this.lastTime = event.timeStamp;
      //si esta vacio resetear
      if (!this.query) {
        return this.reset();
      }

      // si las palabras ingresadas son menores de las minimas requeridas
      if (this.minChars && this.query.length < this.minChars) {
        return;
      }

      setTimeout(() => {

        if (this.objectArray) {
          return this.objectUpdate();
        }

        this.loading = true;

        const re = new RegExp(this.queryParamName, "g");

        this.fetch(this.src.replace(re, encodeURIComponent(this.query))).then(
          response => {

            if (this.query) {
              let data = this.getResponse(response);

             
              // extraer los datos con el limite puesto
              this.data = this.limit ? data.slice(0, this.limit) : data;

              // formar los items
              this.items = this.render(
                this.limit ? data.slice(0, this.limit) : data,
                this
              );

              this.current = -1;
              this.loading = false;

              if (this.selectFirst) {
                this.down();
              }
            }

          }
        );

      }, this.delayTime);
    },

    setActive(index) {
      this.current = index;
    },

    activeClass(index) {
      return this.current === index;
    },

    hit(e) {
      if (this.current !== -1) {
        this.onHit(this.items[this.current], this, this.current, e);
      }
      this.reset();
    },

    up() {
      if (this.current > 0) {
        this.current--;
      } else if (this.current === -1) {
        this.current = this.items.length - 1;
      } else {
        this.current = -1;
      }

      //Por ahora no seleccionar los elementos
      /*if (!this.selectFirst && this.current !== -1) {
        this.onHit(this.items[this.current], this);
      }*/
    },

    down() {
      
      if (this.current < this.items.length - 1) {
        this.current++;
      } else {
        this.current = -1;
      }

      //Por ahora no seleccionar los elementos

      /*if (!this.selectFirst && this.current !== -1) {
        this.onHit(this.items[this.current], this);
      }*/
    },

    

    cleanQuery: function(){

      this.$el.querySelector('input').focus()

      this.clean();

      this.query = '';
      this.reset();
    },

    reset: function() {
      this.items = [];
      this.loading = false;
    }
  },

  watch: {
    value: function(value) {
      this.query = this.query !== value ? value : this.query;
    },
    query: function(value) {
      this.$emit("input", value);
    },
    src: function(value){
      this.src = value;
    }
  },

  computed: {
    vue: function() {
      return this;
    },
    hasItems() {
      return this.items.length > 0;
    },

    isEmpty() {
      return this.query === "";
    },

    isDirty() {
      return !!this.query;
    }
  },

  mounted() {
    this.query = this.value;
    /***
     * 使得其点击之外的部分自动收起
     */
    document.addEventListener("click", e => {
      if (!this.$el.contains(e.target)) {
        this.reset();
      }
    });

    if (this.objectArray) {
      this.objectArray.sort();
    }
  }
};
</script>

<style scoped>

.inputTypeahead{
    width: 100% ;
    z-index: 1;
}

.iconInput{
    z-index: 2;
}

.vs-input--input {
    color: inherit;
    position: relative;
    padding: .4rem;
    font-size: 14px;
    border-radius: 2px;
    border: 1px solid rgba(0,0,0,.2);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-box-shadow: 0 0 0 0 rgba(0,0,0,.15);
    box-shadow: 0 0 0 0 rgba(0,0,0,.15);
    -webkit-transition: all .3s ease;
    transition: all .3s ease;
    width: 100%;
}

.vs-con-input-label.is-label-placeholder {
    margin-top: 20px;
}

.inner-addon {
  position: relative;
}

.inner-addon .glyphicon {
  position: absolute;
  padding: 6px;
  /*pointer-events: none;*/
}

.right-addon .glyphicon {
  right: 0px;
}

.right-addon input {
  padding-right: 30px;
}

ul.typehead {
  position: absolute;
  padding: 0;
  left: 0;
  margin-top: 6px;
  min-width: 100%;
  list-style: none;
  background-color: #fff;
  border-radius: 0 0 2px 2px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  font-size: 12px;
  overflow: hidden;
  z-index: 1000;
}
li.listTypehead {
  padding: 10px 5px 8px 10px;
  min-width: 100%;
  cursor: pointer;
  font-size: 12px;
  border-top: 1px solid #e6e6e6;
}
li.listTypehead:hover {
  background-color: rgba(0, 0, 0, 0.06);
  min-width: 100%;
}
li.listTypehead span:before {
  font-size: 15px;
}
li.listTypehead.left-addon.active span:before {
  color: #2164f9 !important;
}
.active {
  background-color: rgba(0, 0, 0, 0.06);
}
.gifing2 {
  position: absolute;
  margin-top: 3px;
  right: 26px;
  width: 26px;
  height: 26px;
}
</style>

